import styled from 'styled-components';
import colors from '../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  height: auto;
  background-color: ${colors.shades.gamma1};
  width: 100%;

  .rfu-dropzone {
    width: 100%;
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export {
  Container,
  InputContainer,
};
